import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import Preview360 from './Preview360';

const DocumentPreview360 = ({ height, width, ...props }) => {
  const [scale, setScale] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(1);

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <Preview360>
      <Document
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div
            style={{
              height: height || 200,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Spin />
          </div>
        }
        {...props}
        className="PDFDocument"
      >
        <Page
          pageNumber={numPages}
          width={width || 141}
          scale={scale}
          onLoadSuccess={(page) => {
            const newScale = (height || 200) / page.height;
            setScale(newScale);
          }}
        />
        {scale === 1 && (
          <div style={{ textAlign: 'center' }}>
            <Button
              type="link"
              onClick={() => previousPage()}
              disabled={currentPage === 0}
            >
              <LeftOutlined />
              Anterior
            </Button>
            Pág. {currentPage + 1} de {numPages}
            <Button
              type="link"
              onClick={() => nextPage()}
              disabled={currentPage + 1 === numPages}
            >
              Siguiente
              <RightOutlined />
            </Button>
          </div>
        )}
      </Document>
    </Preview360>
  );
};

export default DocumentPreview360;
